export default __webpack_public_path__ + "static/media/fetching.be64c332.gif";